<template>
  <el-dropdown size="small" class="d2-mr">
    <!-- <span class="btn-text">财务账套：{{account.name ? ` ${account.name}` : '未登录'}}</span> -->
    <span class="btn-text">
      当前账套: {{account.name }} {{account.currentYear}}年第{{account.currentMonth}}期
    </span>
    <el-dropdown-menu slot="dropdown">
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import {
    getAccountList
  } from '@/api/finance/setting/account'
  export default {
    data() {
      return {
        accountId: undefined,
        accountList: []
      }
    },
    computed: {
      ...mapState('d2admin/finance', [
        'account'
      ])
    },
    mounted() {
      this.loadCurrentFinance()
    },
    methods: {
      ...mapActions('d2admin/finance', [
        'setCurrentFinance',
        'loadCurrentFinance'
      ])
    }
  }
</script>
<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/mc-header-finance/index.vue"
}
</vue-filename-injector>
